import { WixHelpWidget } from '@wix/wix-help-widget';
import { BiDataWidgetPlacement, OriginApp } from '@wix/wix-help-widget/types';
import React from 'react';
import { useExperiments } from '@wix/wix-experiments-react';
import { ExperimentSpec } from '../../../constants/ExperimentSpec';
import { useMMGRSettings } from '../../../utils/hoc/withMMGRSettings';
import { isStudioEditor } from '../../../utils/env/utils';

const mapOriginToHelpWidget = (mmgrOrigin: string): OriginApp => {
  const origin = (mmgrOrigin || '').toUpperCase();

  if (isStudioEditor()) {
    return OriginApp.StudioEditor;
  }

  switch (origin) {
    case 'EDITOR':
    case 'PICASSO_EDITOR':
    case 'WIXEL_EDITOR':
      return OriginApp.Editor;
    case 'BUSINESS_MANAGER':
      return OriginApp.BusinessManager;
    default:
      return OriginApp.Editor;
  }
};

export const useHelpWidget = () => {
  const { mmgrSettings } = useMMGRSettings();
  const { experiments } = useExperiments();
  const isNewHelpWidgetEnabled = experiments.enabled(ExperimentSpec.UseNewHelpWidget);

  const findFieldType = (article: string): 'articleId' | 'articleUri' => {
    const guidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    const isGuid = guidRegex.test(article);
    return isGuid ? 'articleId' : 'articleUri';
  };

  type OpenHelpWidgetArticleParams = {
    articleUri?: string;
    articleId?: string;
    centerPosition?: boolean;
    biData?: {
      placement?: BiDataWidgetPlacement;
      referral_info?: string;
    };
  };

  const helpWidgetModal = isNewHelpWidgetEnabled ? (
    <WixHelpWidget
      children={<div data-hook="help-widget" />}
      initParams={{
        origin: mapOriginToHelpWidget(mmgrSettings.origin),
        isInvokedFromHeader: true,
      }}
    />
  ) : null;

  const openHelpWidgetArticle = (article: string) => {
    if (!isNewHelpWidgetEnabled || !window.WixSupportChatSDK) {
      return;
    }

    const wixSupportChatSDK = window.WixSupportChatSDK;
    const idOrUri = article.split('/').pop();
    const field = findFieldType(idOrUri);
    const openHelpWidgetArticleParams: OpenHelpWidgetArticleParams = {
      [field]: idOrUri,
      biData: {
        placement: BiDataWidgetPlacement.GFPP,
        referral_info: 'media-manager-g6',
      },
      centerPosition: true,
    };

    wixSupportChatSDK.openHelpWidgetArticle(openHelpWidgetArticleParams);
  };

  return {
    helpWidgetModal,
    openHelpWidgetArticle,
  };
};
